import { ReactComponent as PlayButtonFromFile } from '@/assets/images/svg/buttons/play-button.svg';
import type { FC, SVGProps } from 'react';

/**
 * Each glyph’s source file lives under `src/assets/…`. At build time, Next.js runs those `.svg`
 * files through SVGR (`@svgr/webpack`, wired in `src/next-config/webpack.js`) and exposes them as
 * `ReactComponent`. That’s what we want to render whenever it’s available.
 *
 * Storybook is wired through `@storybook/nextjs`, which normally reuses that same webpack setup.
 * In practice, webpack merges and version bumps don’t always match the main app exactly. When SVGR
 * doesn’t run for a given bundle, `ReactComponent` can be `undefined`. Anything that wraps the
 * icon at module load — for example `styled(SomeGlyph)` — then throws an error before your story renders.
 *
 * The inline SVG below mirrors the asset so icons still show up in Storybook (and any other
 * environment where the loader chain differs) instead of taking down the module graph.
 */
const FallbackPlayGlyph: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg" role="presentation" {...props}>
    <circle cx="24" cy="24" r="24" fill="white" />
    <path d="M18 12L36 24L18 36V12Z" fill="black" />
  </svg>
);

export const PlayButtonGlyph: FC<SVGProps<SVGSVGElement>> =
  typeof PlayButtonFromFile === 'function' ? PlayButtonFromFile : FallbackPlayGlyph;
